<template lang="pug">
  div
    v-container.py-0(style="max-width: 600px;" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'px-5'")
      div.py-1.scrolling-wrapper(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08} !important`")
        v-btn.mr-1.ml-3(color="transparent" small icon @click="showFilter('sort')")
          v-icon(color="basic600" size="20") mdi-sort
        v-chip.s2.mx-1(color="info500" small :dark="Boolean(selectedFilter === 'status')" :outlined="Boolean(selectedFilter !== 'status')" :style="selectedFilter !== 'status' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('status')") Status
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'status' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-chip.s2.mx-1.text-capitalize(v-if="filters.date" color="info500" small :dark="Boolean(selectedFilter === 'date')" :outlined="Boolean(selectedFilter !== 'date')" :style="selectedFilter !== 'date' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('date')") {{ filters.date }}: {{ filters.range.name }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'date' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-chip.s2.mx-1(v-if="filters.shipping" color="info500" small :dark="Boolean(selectedFilter === 'shipping')" :outlined="Boolean(selectedFilter !== 'shipping')" :style="selectedFilter !== 'shipping' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('shipping')") Shipping: {{ shippingText }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'shipping' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-chip.s2.mx-1(v-if="filters.payment" color="info500" small :dark="Boolean(selectedFilter === 'payment')" :outlined="Boolean(selectedFilter !== 'payment')" :style="selectedFilter !== 'payment' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('payment')") Payment: {{ paymentText }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'payment' ? 'mdi-chevron-up' : 'mdi-chevron-down' }} 
        v-chip.s2.mx-1(v-if="filters.source" color="info500" small :dark="Boolean(selectedFilter === 'source')" :outlined="Boolean(selectedFilter !== 'source')" :style="selectedFilter !== 'source' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" link @click="showFilter('source')") Source: {{ sourceText }}
          v-icon(right size="18" style="margin-top: 2px;") {{ selectedFilter === 'source' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
    v-container.pa-0(v-if="selectedFilter" style="max-width: 600px")
      .sort(v-if="selectedFilter === 'sort'")
        sort-order.px-6.pt-4.pb-0(:parentSortOrder.sync="sortOrder")

      .date(v-if="selectedFilter === 'date'")
        date-order.px-6.pt-4.pb-0(:parentDateOrder.sync="dateOrder" :parentRangeOrder.sync="rangeOrder")
      
      .status(v-if="selectedFilter === 'status'")
        div.px-6.pt-4.pb-0
          div.label.basic600--text.text-uppercase {{$t('status')}}
          div.mt-4
            y-checkbox(v-model="arranged" :color="$vuetify.theme.themes[$theme].info500" :readonly="!notArranged")
              template(v-slot:label)
                div.p2.my-auto {{$t('arranged')}}
          div.mt-4
            y-checkbox(v-model="notArranged" :color="$vuetify.theme.themes[$theme].info500" :readonly="!arranged")
              template(v-slot:label)
                div.p2.my-auto {{$t('not_arranged_yet')}}

      .shipping(v-if="selectedFilter === 'shipping'")
        shipping-order.px-6.pt-4.pb-0(:parentShippingOrder.sync="shippingOrder" :company="company")
      
      .payment(v-if="selectedFilter === 'payment'")
        payment-order.px-6.pt-4.pb-0(:parentPaymentOrder.sync="paymentOrder")

      .source(v-if="selectedFilter === 'source'")
        source-order.px-6.pt-4.pb-0.mb-16(:parentSourceOrder.sync="sourceOrder")

      div.d-flex.align-center.pa-4
        v-spacer
        v-btn(v-if="selectedFilter === 'sort' || selectedFilter === 'status'" color='white', text @click="resetFilter")
          .button-Aa-small.primary400--text Reset
        v-btn(v-else color='white', text @click="removeFilter")
          .button-Aa-small.primary400--text Remove
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="updateFilter" dark)
          .button-AA-small.basic100--text Update
</template>

<script>
import { mapGetters } from 'vuex'
import SortOrder from '@/components/ordermgmt/filters/SortOrder.vue'
import DateOrder from '@/components/ordermgmt/filters/DateOrder.vue'
import ShippingOrder from '@/components/ordermgmt/filters/ShippingOrder.vue'
import PaymentOrder from '@/components/ordermgmt/filters/PaymentOrder.vue'
import SourceOrder from '@/components/ordermgmt/filters/SourceOrder.vue'

export default {
  name: 'OrderKanbanFiltersChip',
  components: { SortOrder, DateOrder, ShippingOrder, PaymentOrder, SourceOrder },
  props: ['company', 'parentStatusOrder'],
  data: () => ({
    selectedFilter: null,
    sortOrder: 'newest',
    dateOrder: null,
    rangeOrder: null,
    shippingOrder: null,
    paymentOrder: null,
    sourceOrder: null,
    arranged: true,
    notArranged: true
  }),
  computed: {
    ...mapGetters({
      view: 'orders/getOrderView',
      filters: 'orders/getFilters'
    }),
    statusOrder: {
      get () {
        return this.parentStatusOrder
      },
      set (newValue) {
        this.$emit('update:parentStatusOrder', newValue)
      }
    },
    statusText () {
      let status = []
      if (this.filters.processing && this.filters.processing.length > 0) {
        status.push('Processing')
      }
      if (this.filters.ready && this.filters.ready.length > 0) {
        status.push('Ready')
      }
      return status.toString()
    },
    shippingText () {
      let shipping = ''
      if (this.filters.shipping) {
        if (Object.keys(this.filters.shipping).length > 1) {
          shipping = this.sanitizeString(Object.keys(this.filters.shipping)[0]) + ' and others'
        } else {
          shipping = this.sanitizeString(Object.keys(this.filters.shipping)[0])
        }
      }
      return shipping
    },
    paymentText () {
      let payment = ''
      if (this.filters.payment && this.filters.payment.length > 0) {
        if (this.filters.payment.length > 1) {
          payment = this.filters.payment[0].name + ' and others'
        } else {
          payment = this.filters.payment[0].name
        }
      }
      return payment
    },
    sourceText () {
      let source = ''
      if (this.filters.source && this.filters.source.length > 0) {
        if (this.filters.source.length > 1) {
          source = this.sanitizeString(this.filters.source[0].name) + ' and others'
        } else {
          source = this.sanitizeString(this.filters.source[0].name)
        }
      }
      return source
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.checkFilter()
      }
    }
  },
  mounted () {
    this.checkFilter()
  },
  methods: {
    checkFilter () {
      this.sortOrder = this.filters.sort || 'newest',
      this.dateOrder = this.filters.date || null,
      this.rangeOrder = this.filters.range || null,
      this.shippingOrder = this.filters.shipping || null,
      this.paymentOrder = this.filters.payment || null,
      this.sourceOrder = this.filters.source || null
    },
    showFilter (filter) {
      if (this.selectedFilter === filter) {
        this.selectedFilter = null
      } else {
        this.selectedFilter = filter
      }
    },
    sanitizeString (string) {
      let newstr = string.replace('_', ' ')
      return newstr.charAt(0).toUpperCase() + newstr.slice(1)
    },
    updateFilter () {
      if (this.selectedFilter === 'sort') {
        this.$store.commit('orders/setFilterObject', { key: 'sort', value: this.sortOrder })
      } else if (this.selectedFilter === 'status') {
        this.statusOrder = {
          arranged: this.arranged,
          notArranged: this.notArranged
        }
      } else if (this.selectedFilter === 'date') {
        this.$store.commit('orders/setFilterObject', { key: 'date', value: this.dateOrder })
        this.$store.commit('orders/setFilterObject', { key: 'range', value: this.rangeOrder })
      } else if (this.selectedFilter === 'shipping') {
        this.$store.commit('orders/setFilterObject', { key: 'shipping', value: this.shippingOrder })
      } else if (this.selectedFilter === 'payment') {
        this.$store.commit('orders/setFilterObject', { key: 'payment', value: this.paymentOrder })
      } else if (this.selectedFilter === 'source') {
        this.$store.commit('orders/setFilterObject', { key: 'source', value: this.sourceOrder })
      }
      this.selectedFilter = null
    },
    removeFilter () {
      if (this.selectedFilter === 'sort') {
        this.$store.commit('orders/setFilterObject', { key: 'sort', value: 'newest' })
      } else if (this.selectedFilter === 'date') {
        this.$store.commit('orders/setFilterObject', { key: 'date', value: null })
        this.$store.commit('orders/setFilterObject', { key: 'range', value: null })
      } else if (this.selectedFilter === 'shipping') {
        this.$store.commit('orders/setFilterObject', { key: 'shipping', value: null })
      } else if (this.selectedFilter === 'payment') {
        this.$store.commit('orders/setFilterObject', { key: 'payment', value: null })
      } else if (this.selectedFilter === 'source') {
        this.$store.commit('orders/setFilterObject', { key: 'source', value: null })
      }
      this.selectedFilter = null
    },
    resetFilter () {
      if (this.selectedFilter === 'sort') {
        this.$store.commit('orders/setFilterObject', { key: 'sort', value: 'newest' })
      } else if (this.selectedFilter === 'status') {
        this.arranged = true
        this.notArranged = true
        this.statusOrder = null
      }
      this.selectedFilter = null
    }
  }
}
</script>

<style lang="scss" scoped>
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>